export * from './app-sidebar-nav.component';



// WEBPACK FOOTER //
// D:/desv/producao/hc/angular/adminHC/src/app/components/app-sidebar-nav/index.ts